import Image1 from "../Images/LPU.webp";
import Image2 from "../Images/chandigarh-university.png";
import Image3 from "../Images/VIT-Chennai.webp";
import Image4 from "../Images/Lpu-2.jpg";
import Image5 from "../Images/chandigarh-university-2.jpg";
import Image6 from "../Images/chennai.jpg";




export const collegesdata = [
    {
        id:1,
        Uname:" Lovely Professional University",
        Uplace:"Rajpura, Punjab",
        img:Image1
    },
    {
        id:2,
        Uname:"Chandigarh University - [CU]",
        Uplace:"Gharuan, Punjab",
        img:Image2

    },
    {
        id:3,
        Uname:"VIT-Vellore Institute of Technology",
        Uplace:"Vellore, Chennai",
        img:Image3

    },
]

export const placesdata = [
    {
        id:1,
        place:"Rajpura, Punjab",
        img:Image4  
    },
    {
        id:2,
        place:"Gharuan, Punjab",
        img:Image5
    },
    {
        id:3,
        place:"Vellore, Chennai",
        img:Image6
    },
]

export const higherstudies = [
    {
        id:1,
        Uname:" Lovely Professional University",
        Uplace:"Rajpura, Punjab",
        img:Image1
    },
    {
        id:2,
        Uname:"Chandigarh University - [CU]",
        Uplace:"Gharuan, Punjab",
        img:Image2

    },
    {
        id:3,
        Uname:"VIT-Vellore Institute of Technology",
        Uplace:"Vellore, Chennai",
        img:Image3

    },
]


export const infodata = [
    {
        id:1,
        heading: "Explore Universities, College, and Courses",
        para: "Explore the best colleges and universities based on your interest in the type, of course, you want to choose",
        link: "/explorecollegespage"
    },
    {
        id:2,
        heading: "Free Counselling By Experts",
        para: "Get Free Counselling from our experts and good advice on choosing the best-suited career for your ward",
        link:"/counsellingpage" 
    },
    {
        id:3,
        heading: " Education Loan And Scholarship",
        para: "Get easy loans and scholarships based on various schemes launched by governments and tests conducted by the university.",
        link:"/scholarship"
    },
    {
        id:4,
        heading: "Study Abroad",
        para: "Want to secure your future and go abroad just give it a click and you will be guided with step by step procedure to go abroad and study there.",
        link:""
    },
    {
        id:5,
        heading: "Online Coaching",
        para: " Want the best coaching institutes for your ward to crack various competitive exams? Just click it and you will be redirected to the best online coaching institutes in India.",
        link:""
    },
    {
        id:6,
        heading: "Education News And Exam Updates",
        para: "Just one single click will lead you to the page that consists of all the latest news and exam updates",
        link:"newsfeed"
    },
    
]


export const reviewsData = [

    {
       id : 1,
       title : "College/Universities",
       numbers : "4567+" 
    },
    {
       id : 2,
       title : "E-Books",
       numbers : "3454+" 
    },
    {
       id : 3,
       title : "Counseler",
       numbers : "6787+" 
    },

]
